export default __webpack_public_path__ + "static/media/loannumber.e65cc439.svg";